import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { CompanyOpeningProcess } from '@/types'

export const getCompanyOpeningProcess = async (companyKey: string) => {
  const response = await httpClient('accounting-dealer').get<CompanyOpeningProcess>(
    `/v3/company/${companyKey}/opening-process`,
    {
      ignoreErrorToast: true,
    },
  )
  return response.data
}

export const useGetCompanyOpeningProcess = (
  companyKey: string,
  options?: Partial<
    UseQueryOptions<CompanyOpeningProcess, Error, CompanyOpeningProcess>
  >,
) => {
  return useQuery({
    queryKey: ['company-opening-process', companyKey],
    queryFn: () => getCompanyOpeningProcess(companyKey),
    staleTime: 0,
    ...options,
  })
}
